import React, { SetStateAction } from "react";
import classes from "./SizeSelector.module.scss";
import SizeLabel from "./Elements/SizeLabel";

type Area = number | string;

interface Props {
  sizes: Area[];
  selectedUnitSize: number;
  setSelectedSizeState: React.Dispatch<SetStateAction<number>>;
}

function SizeSelector(props: Props) {
  const labels: Array<number> =
    props.sizes.length % 1
      ? [
          0,
          props.sizes.length - 1,
          Math.round((props.sizes.length - 1) / 2),
          Math.round((props.sizes.length - 1) / 4),
          Math.round((3 * (props.sizes.length - 1)) / 4),
        ]
      : [
          0,
          props.sizes.length - 1,
          Math.round((props.sizes.length - 1) / 3),
          Math.round((props.sizes.length - 1) / 3) * 2,
        ];

  const selectUnitSize = (event: React.ChangeEvent<HTMLInputElement>) => {
    onRangeChange(event);
    props.setSelectedSizeState(parseInt(event.currentTarget.value));
  };

  const onRangeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const el = e.target;
    el.style.setProperty("--value", el.value);
    el.style.setProperty("--min", el.min === "" ? "0" : el.min);
    el.style.setProperty("--max", el.max === "" ? "100" : el.max);
    el.style.setProperty("--value", el.value);
  };

  return (
    <div className={classes.container}>
      <div className={classes.numbers}>
        {props.sizes.map((size, index) => {
          return (
            <SizeLabel
              key={size}
              selectSize={() => props.setSelectedSizeState(index)}
              active={index === props.selectedUnitSize}
              display={props.sizes.length > 15 ? labels.includes(index) : true}
              size={size}
            />
          );
        })}
      </div>
      <div className={classes.slider}>
        {/* <span></span> */}
        <input
          name="sizes"
          type="range"
          min={0}
          max={props.sizes.length - 1}
          className={classes.slider_progress}
          step={1}
          value={props.selectedUnitSize}
          onChange={selectUnitSize}
        />
        {/* <span></span> */}
      </div>
    </div>
  );
}

export default SizeSelector;
